import { render, staticRenderFns } from "./paymentDetail.vue?vue&type=template&id=ece8831a&scoped=true&"
import script from "./paymentDetail.vue?vue&type=script&lang=js&"
export * from "./paymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./paymentDetail.vue?vue&type=style&index=0&id=ece8831a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece8831a",
  null
  
)

export default component.exports